import React from 'react';
import { useBusinessCard } from './BusinessCard';
import {
  Table,
  Grid,
  TableRow,
  TableCell,
  Typography,
  TableBody,
  Collapse,
} from '@material-ui/core';
import { makeStyles } from '@material-ui/styles';

const useStyles = makeStyles((theme) => ({
  collapse: {
    direction: 'rtl',
    width: '100%',
    paddingLeft: '0.5rem',
    paddingRight: '0.5rem',
  },
}));

const OpenningHours = () => {
  const {
    tab,
    dimensions: { vw },
    card: { openningHours = [] },
  } = useBusinessCard();
  const styles = useStyles();

  return (
    <Collapse in={tab === 'openning-hours'} className={styles.collapse}>
      <Grid
        item
        xs={12}
        style={{
          marginBottom: vw(16),
          paddingTop: 0,
        }}
      >
        <Typography>שעות פעילות</Typography>

        <Table>
          <TableBody>
            {openningHours
              .filter((day) => day.isOpen)
              .map((entry) => {
                const { from, to, day } = entry;
                return (
                  <TableRow key={day} style={{ direction: 'rtl' }}>
                    <TableCell align="center">
                      <Typography
                        style={{ fontSize: '0.8rem' }}
                      >{`${from} עד ${to}`}</Typography>
                    </TableCell>
                    <TableCell align="center">
                      <Typography style={{ fontSize: '0.8rem' }}>
                        {day}
                      </Typography>
                    </TableCell>
                  </TableRow>
                );
              })}
          </TableBody>
        </Table>
      </Grid>
    </Collapse>
  );
};

export default OpenningHours;
